"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkCanDeleteApi = checkCanDeleteApi;
exports.createApi = createApi;
exports.deleteApi = deleteApi;
exports.getCardPackageDetail = getCardPackageDetail;
exports.getCardsApi = getCardsApi;
exports.getExchangePageConfigsApi = getExchangePageConfigsApi;
exports.listApi = listApi;
exports.updateApi = updateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
/**
 * 查询福卡包列表
 */
function listApi(params) {
  return (0, _request.default)({
    url: "/admin/card/package/list",
    method: 'GET',
    params: params
  });
}

/**
 * 获取福卡包详情
 */
function getCardPackageDetail(id) {
  return (0, _request.default)({
    url: "/admin/card/package/detail",
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 创建福卡包
 */
function createApi(data) {
  return (0, _request.default)({
    url: "/admin/card/package/save",
    method: 'POST',
    data: data
  });
}

/**
 * 编辑福卡包
 */
function updateApi(data) {
  return (0, _request.default)({
    url: "/admin/card/package/update",
    method: 'POST',
    data: data
  });
}

/**
 * 删除福卡包
 */
function deleteApi(id) {
  return (0, _request.default)({
    url: "/admin/card/package/delete",
    method: 'POST',
    params: {
      id: id
    }
  });
}

/**
 * 获取福卡列表
 */
function getCardsApi() {
  return (0, _request.default)({
    url: "/admin/card/package/valid-cards",
    method: 'GET'
  });
}

/**
 * 检查卡包是否可删除
 */
function checkCanDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/card/package/check-delete",
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 获取兑换页面配置列表
 */
function getExchangePageConfigsApi(params) {
  return (0, _request.default)({
    url: "/admin/company-design/list",
    method: 'GET',
    params: _objectSpread({
      type: 4,
      page: (params === null || params === void 0 ? void 0 : params.page) || 1,
      limit: (params === null || params === void 0 ? void 0 : params.limit) || 20
    }, params)
  });
}